
class Loyalty {
    constructor() {

    }

    async init() {
        if (!window.loyaltyProgram.appId) return;
        const suffixs = ['woman', 'man'];
        const templates = ['index'];

        const appId = `${window.loyaltyProgram.appId}`;
        const accountId = `${window.loyaltyProgram.accountId}`;
        const contactId =`${window.loyaltyProgram.contactId}`;
        const secret = `${window.loyaltyProgram.secretKey}`;
        const timestamp = Math.floor(Date.now() / 1000); // seconds since Unix epoch
        const language =`${window.loyaltyProgram.langIsoCode}`;
        const currency =`${window.loyaltyProgram.currency}`;// optional
        const planId = `${window.loyaltyProgram.planId}`;

        async function generateToken(contactId, planId, timestamp, secret) {
            const encoder = new TextEncoder();
            const data = encoder.encode(contactId + planId + timestamp);
            const key = await crypto.subtle.importKey(
                "raw",
                encoder.encode(secret),
                { name: "HMAC", hash: "SHA-256" },
                false,
                ["sign"]
            );
            const signature = await crypto.subtle.sign("HMAC", key, data);
            return Array.from(new Uint8Array(signature)).map(byte => byte.toString(16).padStart(2, '0')).join('');
        }

        const token = await generateToken(contactId, planId, timestamp, secret);

        let manualShow = false;

        const pageShowWallet = Antonioli.settings.pageShowWallet == 'true'
        const collectionShowWallet = Antonioli.settings.collectionShowWallet == 'true'

        const hasMetafield = pageShowWallet || collectionShowWallet;

        const isTemplateIncluded = suffixs.includes(Antonioli.settings.templateSuffix) || templates.includes(Antonioli.settings.template)

        if (window.innerWidth < 1025 && !isTemplateIncluded && !hasMetafield) {
            manualShow = true
        }

        window.loyalsysSettings = {
            appId,
            contactId,
            timestamp,
            manualShow: manualShow,
            token,
            region: "eu",
            language,
            currency,
            planId
        };

        window.loyalsysSettingsEA = {
            appId,
            accountId,
            contactId,
            timestamp,
            token,
            region: "eu",
            language,
            currency,
            planId
        };
        function loadScript(src) {
            const e = new Date().getTime();
            const t = document.getElementsByTagName("script")[0];
            const n = document.createElement("script");
            n.src = `${src}?x=${e}`;
            n.type = "text/javascript";
            n.async = true;
            n.defer = true;
            t.parentNode.insertBefore(n, t);
        }

        loadScript("https://ui-elements.loyalsys.io/v1.0.1/embed.min.js");
        loadScript("https://exaccess.loyalsys.io/v1.0.1/ls_ea.min.js");
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    await new Loyalty().init()

    window.loyalsysSettings.onInit = () => {
        subscribe(PUB_SUB_EVENTS.openLoyalty, () => {
            window.loyalsysSettings.ShowWallet()
        })

    }

})
